import { takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './taxFormsActions';
import { getLastSyncDate } from './taxFormsSelectors';
import { transformResponseToTaxForms } from './taxFormsTransformers';

const mkResourceConfig = (successAction, failureAction) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'tax-forms',
    resourceBaseUrl: 'categories/tax-forms',
    getLastSyncDate,

    transformResponseToResources: transformResponseToTaxForms,

    successAction,
    failureAction,
  });

export function* getTaxFormsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getTaxFormsSuccess, actions.getTaxFormsFailure);
  yield takeLeading(actions.getTaxForms, resourceSagaUtils.qcsSyncGetResources, resourceConfig);
}

export default [getTaxFormsActionWatcher];
